import { useEffect, useRef } from 'react';

import { useSearchParams } from 'react-router';

import { useWidgetAnimation } from '@/features/Dashboard/context/WidgetAnimation/hooks';
import { sanitizeName } from '@/utils/sanitizeName';

export const useBlockTabNavigation = <T extends { name: string }>(
  tabs: T[],
  setActiveTab: (id: number) => void
) => {
  const blockRef = useRef<HTMLDivElement>(null);
  const [urlSearchParams, setSearchParams] = useSearchParams();
  const { setElementsToAnimateId } = useWidgetAnimation();

  const params = urlSearchParams.get('element');
  useEffect(() => {
    if (params) {
      const element = params.split(',')?.[0];
      if (element) {
        const [, tabId] = element.split(':');
        const tabIndex = tabs.findIndex(tab => sanitizeName(tab.name) === tabId);
        if (tabIndex !== -1) {
          setActiveTab(tabIndex);
          const containerId = blockRef.current?.closest('[id]')?.id;
          if (containerId) {
            setElementsToAnimateId(new Set([containerId]));
          }
        }
        setSearchParams({});
      }
    }
  }, []);
  return { blockRef };
};
